/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
/**
 * Track mouse over states for 3d objects.
 */
export class MouseOverTracker {
    constructor(host) {
        this._mouseOverIntersections = new Map();
        this.host = host;
    }
    emit(intersections) {
        const newMouseOverIntersections = new Set();
        const mouseOutIntersections = new Map();
        for (const [uuid, inter] of this._mouseOverIntersections) {
            if (!intersections.find(({ object }) => object.uuid === uuid)) {
                mouseOutIntersections.set(uuid, inter.object);
            }
        }
        intersections.forEach((inter) => {
            const { uuid } = inter.object;
            if (!this._mouseOverIntersections.has(uuid)) {
                newMouseOverIntersections.add(inter);
                this._mouseOverIntersections.set(uuid, inter);
            }
        });
        for (const [uuid, obj3d] of mouseOutIntersections) {
            obj3d.userData.isOver = false;
            this.host.onMouseOut(obj3d);
            this._mouseOverIntersections.delete(uuid);
        }
        for (const inter of newMouseOverIntersections) {
            inter.object.userData.isOver = true;
            this.host.onMouseOver(inter);
        }
    }
}
//# sourceMappingURL=MouseOverTracker.js.map